var map = {
	"./shared-messages.en.json": "./src/app/shared/service/message-manager/messages/shared/shared-messages.en.json",
	"./shared-messages.it.json": "./src/app/shared/service/message-manager/messages/shared/shared-messages.it.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/app/shared/service/message-manager/messages/shared sync recursive ^\\.\\/shared\\-messages\\..*\\.json$";